import * as React from 'react';
import { SVGProps } from 'react';
export const DateRange = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden={true}
    focusable={false}
    {...props}
  >
    <path
      d="M7.455 11.954H5.637v.91h1.818v-.91ZM12.908 11.954H11.09v.91h1.818v-.91ZM7.455 16.499H5.637v.91h1.818v-.91ZM12.908 16.499H11.09v.91h1.818v-.91ZM18.365 11.954h-1.818v.91h1.818v-.91Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.455 11.954H5.637v.91h1.818v-.91ZM12.908 11.954H11.09v.91h1.818v-.91ZM7.455 16.499H5.637v.91h1.818v-.91ZM12.908 16.499H11.09v.91h1.818v-.91ZM18.365 11.954h-1.818v.91h1.818v-.91Z"
      fill="currentColor"
    />
    <path
      d="M20.182 3.772H3.818A1.818 1.818 0 0 0 2 5.591v13.636c0 1.004.814 1.818 1.818 1.818h16.364A1.818 1.818 0 0 0 22 19.227V5.591a1.818 1.818 0 0 0-1.818-1.819ZM6.547 1.954v2.727M17.453 1.954v2.727M2 8.317h20"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
